import { Injectable } from '@angular/core';
import { Adapter } from '@app/core/adapter';
import { UserPreferences } from '@app/shared/models/user-preferences.model';

@Injectable()
export class UserPreferencesAdapter implements Adapter<UserPreferences> {
    adapt(data: any): UserPreferences {
        return {
            useMetricUnits: !!data.useMetricUnits,
            use24HourClock: !!data.use24HourClock,
        } as UserPreferences;
    }
}
